import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportCounterPage } from './report-counter.page';

const routes: Routes = [
  {
    path: '',
    component: ReportCounterPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportCounterPageRoutingModule {}
